import { CurrencyModel } from 'models/Settings/Financial/CurrencyModel';
import { ReservationCardGroupModel } from 'pages/ReservationModule/pages/CreateReservationPageNew/models';
import { NationalityModel } from '../../../../../../../services/Settings/NationalityService';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export interface NationalityForecastReportFormModel {
  from: string | null;
  to: string | null;
  company: ReservationCardGroupModel | null;
  nationality: NationalityModel | null;
  roomTypeIds: number[] | null;
  gross_revenue: boolean;
  with_revenue: boolean;
  currency: CurrencyModel | null;
  currency_application: CurrencyApplicationEnum | null;
  fixed_at: string | null;
  file_type: exportFileTypes;
}

export enum CurrencyApplicationEnum {
  FIXED = 'fixed',
  DAILY = 'daily',
}
